import React, { Component } from "react";
import Leaflet from "leaflet";
import { Map, TileLayer, Marker, Circle } from "react-leaflet";

Leaflet.Icon.Default.imagePath =
    "//cdnjs.cloudflare.com/ajax/libs/leaflet/1.5.1/images/";

export default class MapComponents extends Component {

    constructor(props) {
        super(props);
        const params = new URLSearchParams(props.location.search);
        const lat = params.get('lat') ?? 35.68886;   // 35.68886;
        const lon = params.get('lon') ?? 139.69863;   // 139.69863;
        const zoom = params.get('zoom') ?? 16; // 16;
        const mlat = params.get('mlat') ?? 35.68886;   // 35.68886;
        const mlon = params.get('mlon') ?? 139.68767;   // 139.68767;
        const radius = params.get('radius') ?? 0;   // meters;

        this.state = {
            lat: Number(lat),
            lon: Number(lon),
            zoom: Number(zoom),
            target: {
                coordinates: {
                    lat: Number(mlat),
                    lon: Number(mlon)
                },
                radius: Number(radius)
            }
        };
    }

    render() {
        const osmAttribution = '© <a href="http://osm.org/copyright">OpenStreetMap</a> contributors';
        const temposmartTileUrl = process.env.REACT_APP_TILE_URL;

        return (
            <Map center={[this.state.lat, this.state.lon]} zoom={this.state.zoom} zoomControl={false}>
                <TileLayer attribution={osmAttribution} url={temposmartTileUrl} />
                {this.state.target.radius > 0
                    ? <Circle center={this.state.target.coordinates} radius={this.state.target.radius}/>
                    : <Marker position={this.state.target.coordinates} />
                }
            </Map>
        );
    }
}

